module.exports = __webpack_public_path__ + "static/media/drag-drop.872b7df2.svg";